<template>
  <BasePopup ref="basePopup" :title="title" class="confirmation-popup">
    <p v-if="$slots.default">
      <slot></slot>
    </p>

    <template #buttons>
      <AppButton
        class="confirmation-popup__btn confirmation-popup__btn--cancel"
        :outlined="true"
        :loading="currentlyLoadingButton === 'cancel'"
        :disabled="currentlyLoadingButton !== null"
        @click="handleClick('cancel')"
      >
        <slot name="cancel">Cancel</slot>
      </AppButton>

      <AppButton
        class="confirmation-popup__btn confirmation-popup__btn--confirm"
        :loading="currentlyLoadingButton === 'confirm'"
        :disabled="currentlyLoadingButton !== null"
        :danger="danger"
        @click="handleClick('confirm')"
      >
        <slot name="confirm">Confirm</slot>
      </AppButton>
    </template>

    <p v-if="showError" class="confirmation-popup__error">
      An unexpected error ocurred. Please try again later.
    </p>
  </BasePopup>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import BasePopup from '@/components/ui/BasePopup.vue'
import AppButton from '@/app/components/button/AppButton.vue'

const props = defineProps<{
  title: string
  onCancel: () => boolean | Promise<boolean>
  onConfirm: () => boolean | Promise<boolean>
  danger?: boolean
}>()

const basePopup = ref<InstanceType<typeof BasePopup> | null>(null)
const currentlyLoadingButton = ref<'cancel' | 'confirm' | null>(null)
const showError = ref(false)

async function handleClick(buttonType: 'cancel' | 'confirm'): Promise<void> {
  showError.value = false
  currentlyLoadingButton.value = buttonType

  const success =
    buttonType === 'confirm' ? await props.onConfirm() : await props.onCancel()

  if (success) {
    basePopup.value?.hide()
  } else {
    showError.value = true
  }

  currentlyLoadingButton.value = null
}

function show(): void {
  basePopup.value?.show()
}

defineExpose({ show })
</script>
